// import PropTypes from 'prop-types'
// import React, { useState } from "react"
// import { connect, useSelector } from "react-redux"
// import LanguageDropdown from "../CommonForBoth/TopbarDropdown/LanguageDropdown"
// import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown"
// import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu"
// import {
//   showRightSidebarAction,
//   toggleLeftmenu,
//   changeSidebarType,
// } from "../../store/actions"
// import moment from 'moment';
// import { ADMIN_USER_TYPE_ID, MERCHANT_USER_TYPE_ID } from '../../Constants/MainKeys';
// import { useDispatch } from "react-redux"
// import { setSiteTourIsNotified } from '../../store/intro/actions';
// import { Tooltip, OverlayTrigger } from 'react-bootstrap';
// import { Link } from 'react-router-dom';

// const Header = () => {

//   const { language } = useSelector(state => state.Languages);
//   const { stepsData } = useSelector((state) => state.Intro);
//   const dispatch = useDispatch()
//   const { user } = useSelector(state => state.Login)


//   function tToggle() {
//     var body = document.body;
//     body.classList.toggle("vertical-collpsed");
//     body.classList.toggle("sidebar-enable");
//   }

//   return (
//     <React.Fragment>
//       <header id="page-topbar">
//         <div className="navbar-header">
//           <div className="d-flex align-items-center">
//             <button
//               type="button"
//               onClick={() => {
//                 tToggle()
//               }}
//               className="btn btn-sm px-3 font-size-16 header-item "
//               id="vertical-menu-btn"
//             >
//               <i className="fa fa-fw fa-bars" />
//             </button>
//             <div className="h-100 d-flex align-items-center">
//               <h4 className=" mb-0 text-nowrap">{moment(new Date()).format("LL")}</h4>
//             </div>
//             {
//               user.userTypeId === MERCHANT_USER_TYPE_ID ?
//                 <div className="h-100 d-flex align-items-center mx-3">
//                   <div className='me-1' style={{ backgroundColor: `${user.isActive ? "#34c38f" : "#f46a6a"}`, width: "10px", height: "10px", borderRadius: "50%", marginBottom: "2px" }} />
//                   {
//                     user.isActive ?
//                       <span className="ms-1 mb-0 text-nowrap fw-500">Verified account</span>
//                       :
//                       <div>
//                         <OverlayTrigger
//                           placement="bottom"
//                           overlay={(item) =>
//                             <Tooltip {...item}>
//                               Current organization has not been approved by the Cryllex administration.
//                             </Tooltip>
//                           }
//                         >
//                           <span className='ms-1 mb-0 text-nowrap fw-500'>Unverified account</span>
//                         </OverlayTrigger>
//                       </div>
//                   }
//                 </div>
//                 : null
//             }
//           </div>
//           <div className="d-flex align-items-center">


//             <LanguageDropdown />
//             {
//               user.userTypeId === MERCHANT_USER_TYPE_ID ?
//                 <button
//                   title='Download PDF'
//                   type="button"
//                   className="btn header-item noti-icon "
//                   data-toggle="fullscreen"
//                 >
//                   <i className='bx bx-download' ></i>
//                 </button>
//                 : null
//             }
//             <div className="dropdown d-none d-lg-inline-block">
//               {/* <button
//                 type="button"
//                 onClick={() => {
//                   toggleFullscreen()
//                 }}
//                 className="btn header-item noti-icon "
//                 data-toggle="fullscreen"
//               >
//                 <i className="bx bx-fullscreen" />
//               </button> */}
//               {
//                 stepsData && stepsData.data && JSON.parse(stepsData.data).length > 0 ?
//                   <button
//                     type="button"
//                     className="btn header-item noti-icon "
//                     data-toggle="fullscreen"
//                     onClick={() => {
//                       dispatch(setSiteTourIsNotified(false));
//                     }}
//                   >
//                     <i
//                       className='bx bx-directions'
//                     ></i>
//                   </button>
//                   : null
//               }

//               {/* <a
//                 href={`https://cryllex.${MainService.getUrlExtension()}/contact-us`}
//                 target='_blank'
//               >
//                 <button
//                   type="button"
//                   className="btn header-item noti-icon "
//                   data-toggle="fullscreen"
//                 >
//                   <i className='bx bx-support'></i>
//                 </button>
//               </a> */}
//               {
//                 user?.userTypeId === ADMIN_USER_TYPE_ID ? null :
//                   <Link
//                     to={`/${language}/customer-support`}
//                   >
//                     <button
//                       type="button"
//                       className="btn header-item noti-icon"
//                     >
//                       <i className='bx bx-support'></i>
//                     </button>
//                   </Link>
//               }
//             </div>

//             <NotificationDropdown />

//             <ProfileMenu />

//           </div>
//         </div>

//       </header>

//       {/* <ReactDrawer
//         open={open}
//         position={position}
//         onClose={onDrawerClose}
//       >
//         <RightSidebar onClose={onDrawerClose} />
//       </ReactDrawer> */}
//     </React.Fragment>
//   )
// }

// Header.propTypes = {
//   changeSidebarType: PropTypes.func,
//   leftMenu: PropTypes.any,
//   leftSideBarType: PropTypes.any,
//   showRightSidebar: PropTypes.any,
//   showRightSidebarAction: PropTypes.func,
//   t: PropTypes.any,
//   toggleLeftmenu: PropTypes.func
// }

// const mapStatetoProps = state => {
//   const {
//     layoutType,
//     showRightSidebar,
//     leftMenu,
//     leftSideBarType,
//   } = state.Layout
//   return { layoutType, showRightSidebar, leftMenu, leftSideBarType }
// }

// export default connect(mapStatetoProps, {
//   showRightSidebarAction,
//   toggleLeftmenu,
//   changeSidebarType,
// })((Header))



import React from "react";
import { useSelector, useDispatch } from "react-redux";
import LanguageDropdown from "../CommonForBoth/TopbarDropdown/LanguageDropdown";
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown";
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { Link } from "react-router-dom";
import moment from "moment";
import { ADMIN_USER_TYPE_ID, MERCHANT_USER_TYPE_ID } from "../../Constants/MainKeys";
import { setSiteTourIsNotified } from "../../store/intro/actions";

const Header = () => {
  const dispatch = useDispatch();
  const { language } = useSelector((state) => state.Languages);
  const { stepsData } = useSelector((state) => state.Intro);
  const { user } = useSelector((state) => state.Login);

  const tToggle = () => {
    document.body.classList.toggle("vertical-collpsed");
    document.body.classList.toggle("sidebar-enable");
  };

  return (
    <header id="page-topbar">
      <div className="navbar-header">
        <div className="d-flex align-items-center">
          <button
            type="button"
            onClick={tToggle}
            className="btn btn-sm px-3 font-size-16 header-item"
            id="vertical-menu-btn"
          >
            <i className="fa fa-fw fa-bars" />
          </button>

          <div className="h-100 d-flex align-items-center">
            <h4 className="mb-0 text-nowrap">{moment(new Date()).format("LL")}</h4>
          </div>

          {user?.userTypeId === MERCHANT_USER_TYPE_ID && (
            <div className="h-100 d-flex align-items-center mx-3">
              <div
                className="me-1"
                style={{
                  backgroundColor: user.isActive ? "#34c38f" : "#f46a6a",
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  marginBottom: "2px",
                }}
              />
              {user.isActive ? (
                <span className="ms-1 mb-0 text-nowrap fw-500">Verified account</span>
              ) : (
                <OverlayTrigger
                  placement="bottom"
                  overlay={(props) => (
                    <Tooltip {...props}>
                      Current organization has not been approved by the Cryllex administration.
                    </Tooltip>
                  )}
                >
                  <span className="ms-1 mb-0 text-nowrap fw-500">Unverified account</span>
                </OverlayTrigger>
              )}
            </div>
          )}
        </div>

        <div className="d-flex align-items-center">
          <LanguageDropdown />

          {user?.userTypeId === MERCHANT_USER_TYPE_ID && (
            <button
              title="Download PDF"
              type="button"
              className="btn header-item noti-icon"
            >
              <i className="bx bx-download"></i>
            </button>
          )}

          <div className="dropdown d-none d-lg-inline-block">
            {stepsData?.data && JSON.parse(stepsData.data).length > 0 && (
              <button
                type="button"
                className="btn header-item noti-icon"
                onClick={() => dispatch(setSiteTourIsNotified(false))}
              >
                <i className="bx bx-directions"></i>
              </button>
            )}

            {user?.userTypeId !== ADMIN_USER_TYPE_ID && (
              <Link to={`/${language}/customer-support`}>
                <button type="button" className="btn header-item noti-icon">
                  <i className="bx bx-support"></i>
                </button>
              </Link>
            )}
          </div>

          <NotificationDropdown />
          <ProfileMenu />
        </div>
      </div>
    </header>
  );
};

export default Header;
